import { render, staticRenderFns } from "./office-detail-modal-2.vue?vue&type=template&id=52b52a9d&"
import script from "./office-detail-modal-2.vue?vue&type=script&lang=js&"
export * from "./office-detail-modal-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports